<template>
  <div class="rma-messagelist_wrap">
    <h3>{{$t('rma.history')}}</h3>
    <p v-if="currentUser">{{ currentUser.firstname }} {{ currentUser.lastname }} </p>
      <ul class="rma-messagelist">
      <li v-for="(message, index) in messages" :key="index" :class="['msg-' + message.type]">
        <div class="rma-msg_title text-right">{{formatDate(message.date, $t('dateFormatLong'))}}</div>
        <div class="rma-msg_body">
          <div class="rma-msg_body_msg" v-html="message.message"/>
          <div class="rma-msg_body_attachment mt-2" v-if="message.attachments && message.attachments.length">
            <div
              v-for="(attachment, indexAttach) in message.attachments"
              :key="indexAttach"
              class="rma-msg_body_attachment__file mb-2">
              <a
                class="bcm-link bcm-link-secondary"
                :href="attachment.url"
                >
                {{attachment.name}}
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapState } from 'vuex'

export default {
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate (date, format) {
      return dayjs(date).format('DD/MM/YYYY HH:mm')
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.current
    })
  }
}
</script>
